import React, { useState, useEffect } from 'react';
import './nossas_lojas.css';
import Header from '../componentes/header/header';
import Footer from '../componentes/footer/footer';

const NossasLojas = () => {

  useEffect(() => {
    document.title = "Trinco | Nossas lojas";
  }, []);

  const lojas = [
    {
      id: 18,
      nome: "Trinco Salvador Shopping",
      razaoSocial: "MBL PRESENTES E SERVICOS LTDA",
      endereco: "Avenida Tancredo Neves, Salvador Shopping, Loja 1048, 1º piso, Salvador - BA, CEP: 41.820-021.",
      telefone: "(71) 99602-7421",
      zap: "5571996027421",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.828236166455!2d-38.4551223!3d-12.9776884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92a516510cac211f%3A0xd5a41097a534a48b!2sSalvador%20Shopping!5e0!3m2!1spt-BR!2sbr!4v1710000000000!5m2!1spt-BR!2sbr"
    },
    {
      id: 1002,
      nome: "Trinco Bela Vista",
      razaoSocial: "JL PRESENTES E SERVICOS LTDA",
      endereco: "Alameda Euvaldo Luz, Shopping Bela Vista, Loja 06, 1º piso, Salvador - BA, CEP: 41.098-020.",
      telefone: "(71) 99608-7125",
      zap: "5571996087125",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.954641474274!2d-38.4746357!3d-12.9699536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92a519d9dd7297d1%3A0x2449542f298835ab!2sShopping%20Bela%20Vista!5e0!3m2!1spt-BR!2sbr!4v1710000000000!5m2!1spt-BR!2sbr"
    },
    {
      id: 1005,
      nome: "Trinco Parque Shopping",
      razaoSocial: "JL PRESENTES E SERVICOS LTDA",
      endereco: "Avenida Santos Dumont, Parque Shopping, Loja 1076, 1º piso, Lauro de Freitas - BA, CEP: 42.702-400.",
      telefone: "(71) 99669-1181",
      zap: "5571996691181",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.6674645228516!2d-38.3185516!3d-12.8876681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92e0173570dd256d%3A0x82ca17b7ec80b896!2sParque%20Shopping%20Bahia!5e0!3m2!1spt-BR!2sbr!4v1710000000000!5m2!1spt-BR!2sbr"
    },
    {
      id: 8,
      nome: "Trinco Feira de Santana",
      razaoSocial: "JL COMERCIO DE PRESENTES E SERVICOS LTDA",
      endereco: "Avenida Governador João Durval Carneiro, Shopping Boulevard, Loja 235, 1° piso, Feira de Santana - BA, CEP: 44.052-064.",
      telefone: "(75) 99201-4399",
      zap: "5575992014399",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3899.274191632738!2d-38.9480838239801!3d-12.232338159938814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x714382a4e56627b3%3A0x5948a2555c283044!2sBoulevard%20Shopping%20Feira%20de%20Santana!5e0!3m2!1spt-BR!2sbr!4v1709240300000!5m2!1spt-BR!2sbr"
    },
    {
      id: 12,
      nome: "Trinco Salvador Norte Shopping",
      razaoSocial: "JL COMERCIO DE PRESENTES E SERVICOS LTDA",
      endereco: "Rodovia BA 526, Salvador Norte Shopping, Loja 1062, 1° piso, Salvador - BA, CEP: 41.510-000.",
      telefone: "(71) 99764-1199",
      zap: "5571997641199",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.855269785121!2d-38.3539082241604!3d-12.908373187399813!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x71601a4d4b1cff7f%3A0x43c6cdcb95b47e2b!2sSalvador%20Norte%20Shopping!5e0!3m2!1spt-PT!2sbr!4v1700000000000!5m2!1spt-PT!2sbr"
    },
    {
      id: 22,
      nome: "Trinco Max Center",
      razaoSocial: "JL COMERCIO DE PRESENTES E SERVICOS LTDA",
      endereco: "Avenida Antônio Carlos Magalhães, Max Center, Loja 18, Salvador - BA, CEP: 41.825-900.",
      telefone: "(71) 99379-2922",
      zap: "5571993792922",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.0068478142316!2d-38.46795112411516!3d-12.97141515984668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x71606b69db75b647%3A0xcfad3700bb5e66f5!2sMax%20Center%20-%20Tricenter!5e0!3m2!1spt-BR!2sbr!4v1714000000000!5m2!1spt-BR!2sbr"
    },
    {
      id: 26,
      nome: "Trinco Paralela",
      razaoSocial: "MBL PRESENTES E SERVICOS LTDA",
      endereco: "Avenida Luís Viana Filho, Shopping Paralela, Loja 103, 1° piso, Salvador - BA, CEP: 41.730-101.",
      telefone: "(71) 99714-9047",
      zap: "5571997149047",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.804473873499!2d-38.39740192398968!3d-12.936180259309852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7160384e01be91a1%3A0xc2e103a0a2f7e845!2sShopping%20Paralela!5e0!3m2!1spt-PT!2sbr!4v1735328514867!5m2!1spt-PT!2sbr"
    },
    {
      id: 1004,
      nome: "Trinco Barra",
      razaoSocial: "MBL PRESENTES E SERVICOS LTDA",
      endereco: "Avenida Centenário, Shopping Barra, Loja 154, 1º piso, Salvador - BA, CEP: 40.140-400.",
      telefone: "(71) 99963-7208",
      zap: "5571999637208",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.211425028565!2d-38.52651172421332!3d-13.00582328731215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x71604078108013cb%3A0x4caea6cbdb92151f!2sShopping%20Barra!5e0!3m2!1spt-PT!2sbr!4v1735328639000!5m2!1spt-PT!2sbr"
    },
    {
      id: 1003,
      nome: "Trinco Shopping da Bahia",
      razaoSocial: "JL PRESENTES E SERVICOS LTDA",
      endereco: "Avenida Tancredo Neves, Shopping da Bahia, Loja 08, 1° piso, Salvador - BA, CEP: 41.820-020.",
      telefone: "(71) 99760-1199",
      zap: "5571997601199",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.8920108398416!2d-38.467139785177894!3d-12.978768090851167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x71601b3d5449aa97%3A0xe54537c7ceb6a42a!2sShopping%20da%20Bahia!5e0!3m2!1spt-BR!2sbr!4v1700000000000!5m2!1spt-BR!2sbr"
    },
    {
      id: 1006,
      nome: "Trinco Shopping Piedade",
      razaoSocial: "TRINCO PRESENTES E SERVICOS LTDA",
      endereco: "Rua Conselheiro Junqueira Ayres, Shopping Piedade, Loja 211, 3° piso, Salvador - BA, CEP: 40.070-080.",
      telefone: "(71) 3901-4147",
      zap: "557139014147",
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.892663242633!2d-38.51565032414777!3d-12.97871638733737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x716044930ba7d701%3A0xc202520745bd9bd7!2sShopping%20Piedade!5e0!3m2!1spt-BR!2sbr!4v1735328825000!5m2!1spt-BR!2sbr"
    }
  ];

  const [lojaAtiva, setLojaAtiva] = useState(lojas[0]);
  return (
    <>
      <Header />
      <div className="lojas-page container-fluid py-5">
        <div className="container">
          <h2 className="mb-4 text-success fw-bold">Nossas Lojas</h2>

          <div className="row">
            {/* LISTA DE LOJAS */}
            <div className="col-lg-4 mb-4">
              <div className="list-group shadow-sm">
                {lojas.map((loja) => (
                  <button
                    key={loja.id}
                    onClick={() => setLojaAtiva(loja)}
                    className={`list-group-item list-group-item-action p-3 ${lojaAtiva.id === loja.id ? 'active-loja' : ''}`}
                  >
                    <h5 className="mb-1 fw-bold">{loja.nome}</h5>
                    <p className="mb-1 small text-muted">{loja.endereco}</p>
                  </button>
                ))}
              </div>
            </div>

            {/* DETALHES E MAPA */}
            <div className="col-lg-8">
              <div className="card border-0 shadow-sm p-4 mb-4">
                <div className="row">
                  <div className="col-md-7">
                    <h3 className="text-success fw-bold">{lojaAtiva.nome}</h3>
                    <p className="mb-1"><strong>Endereço:</strong> {lojaAtiva.endereco}</p>
                    <p className="mb-0"><strong>Telefone:</strong> {lojaAtiva.telefone}</p>
                  </div>
                  <div className="col-md-5 d-flex align-items-center justify-content-md-end mt-3 mt-md-0">
                    <a
                      href={`https://wa.me/${lojaAtiva.zap}?text=Olá, estou em frente a loja ${lojaAtiva.nome}`}
                      target="_blank"
                      className="btn btn-success px-4"
                    >
                      Falar com esta loja
                    </a>
                  </div>
                </div>
              </div>

              {/* MAPA */}
              <div className="map-container shadow-sm rounded overflow-hidden">
                <iframe
                  title="Mapa da Loja"
                  src={lojaAtiva.mapUrl}
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default NossasLojas;